'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" {...props}><path fill="currentColor" fillRule="evenodd" d="m3.844 3.9.027-.029a10.083 10.083 0 0 1 14.26 14.258.917.917 0 1 1-1.297-1.296 8.25 8.25 0 0 0-.001-11.665 8.25 8.25 0 0 0-11.664 0 8.25 8.25 0 0 0 0 11.665.917.917 0 1 1-1.296 1.296 10.083 10.083 0 0 1-.029-14.23m2.707 2.482a6.417 6.417 0 0 1 8.994.084q.039.038.071.08a6.416 6.416 0 0 1-.08 8.998.917.917 0 1 1-1.295-1.297 4.58 4.58 0 0 0 0-6.485 1 1 0 0 1-.062-.067 4.584 4.584 0 0 0-6.417.066 1 1 0 0 1-.07.064 4.583 4.583 0 0 0 .07 6.413.917.917 0 1 1-1.295 1.297 6.417 6.417 0 0 1 0-9.08 1 1 0 0 1 .084-.074m5.025 7.308q-.279.06-.576.06a2.75 2.75 0 1 1 .576-.06M9.167 16.5a1.833 1.833 0 0 1 3.667 0v2.75a1.833 1.833 0 1 1-3.667 0z" clipRule="evenodd" /></svg>;
const IconPodcast = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconPodcast;